import {h, Component} from 'preact'
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants, { MyMenusPath } from '../constants';
import util from "../util";
import { CloudUploadOutlined, DownOutlined, SearchOutlined } from '@ant-design/icons';
import FontFamily from "./svg/FontFamily";

export default @connect(reduce, actions)
class FontFamilyWidget extends Component {
  constructor() {
    super();
    this.state = {
      customFonts: [],
      searchBy: ''
    };
    this.goToBrandingPage = () => {
      window.open(MyMenusPath + '/brand', '_blank');
    };

    this.onSearchClick = function(ev) {
      ev.stopPropagation();
      util.nextTick(() => {
        ev.target.focus();
      })
    }

    this.onChangeSearchField = (ev) => {
      const $dropdown = $('.fontfamily-dropdown');
      this.setState({searchBy: ev.target.value});
      let term = this.state.searchBy.toLowerCase();

      if (term === '') {
          $dropdown.find('.scroll').find('li').each(function () {
          $(this).show()
        });
        $('.no-matches').hide();
        return;
      }

      $dropdown.find('.scroll').find('li').each(function () {
        if ($(this).first().text().toLowerCase().startsWith(term)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      let someRemain = $dropdown.find('.scroll').find('li').filter(function () {
        return $(this).css('display') !== 'none';
      }).length > 0;
      if (someRemain) {
        $('.no-matches').hide();
      } else {
        $('.no-matches').show();
      }
    }
  }

  componentDidMount() {
  }

  render(props, state) {
    const fonts = constants.fonts.map((font) =>
      <li>
        <a className={font.key} onClick={() => props.changeFont(font)}>{font.label}</a>
      </li>
    );
    const customFonts = constants.customFonts.map((customFont) =>
      <li>
        <a className={customFont.key} onClick={() => props.changeFont(customFont)} style={{fontFamily: customFont.font + ', serif'}}>{customFont.label}</a>
      </li>
    );
    const customFontNames = constants.customFonts.map((customFont) => customFont.font);

    let favoriteFontHeader = null;
    if (constants.favoriteFonts['HEADER'] && !customFontNames.includes(constants.favoriteFonts['HEADER'].name)) {
      let headerFontFamilyObj = util.getFontByFamily(constants.favoriteFonts['HEADER'].name)
      if (headerFontFamilyObj) {
        favoriteFontHeader = <li>
          <a className={headerFontFamilyObj.key} onClick={() => props.changeFont(headerFontFamilyObj)}>{headerFontFamilyObj.label}</a>
        </li>
      }
    }

    let favoriteFontSubHeader = null;
    if (constants.favoriteFonts['SUB-HEADER'] && !customFontNames.includes(constants.favoriteFonts['SUB-HEADER'].name)) {
      let subHeaderFontFamilyObj = util.getFontByFamily(constants.favoriteFonts['SUB-HEADER'].name);
      if (subHeaderFontFamilyObj) {
        favoriteFontSubHeader = <li>
          <a className={subHeaderFontFamilyObj.key} onClick={() => props.changeFont(subHeaderFontFamilyObj)}>{subHeaderFontFamilyObj.label}</a>
        </li>
      }
    }

    let favoriteFontBodyText = null;
    if (constants.favoriteFonts['BODY TEXT'] && !customFontNames.includes(constants.favoriteFonts['BODY TEXT'].name)) {
      let bodyTextFontFamilyObj = util.getFontByFamily(constants.favoriteFonts['BODY TEXT'].name);
      if (bodyTextFontFamilyObj) {
        favoriteFontBodyText = <li>
          <a className={bodyTextFontFamilyObj.key} onClick={() => props.changeFont(bodyTextFontFamilyObj)}>{bodyTextFontFamilyObj.label}</a>
        </li>
      }
    }

    const showCustomFonts = (constants.customFonts.length > 0 || favoriteFontHeader != null || favoriteFontSubHeader != null || favoriteFontBodyText != null);
    let customFontsLabel = null;
    // if (props.hasPdfPermission) {
      customFontsLabel = <li className="lbl">My Fonts</li>
    // } else {
    //   customFontsLabel = <li className="lbl"><img src="http://musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg" className={"star-icon"} alt="" />
    //     <div className={"lblText"}>My Fonts</div>
    //   </li>
    // }

    const customFontsSeparator = <li className="sep" />;
    let myFontsPromotionLbl = null;

    // if (!showCustomFonts) {
      myFontsPromotionLbl = <li className={"myFontsPromotionCont"} onClick={this.goToBrandingPage}>
        <div className={"myFontsPromotion"}>
          {props.hasPdfPermission && <CloudUploadOutlined />}
          Upload a font
          {!props.hasPdfPermission && <img src="http://musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg" className={"star-icon"} alt="" />}
        </div>
      </li>
    // }

    const multiLangFonts = constants.multiLangFonts.map((font) =>
      <li>
        <a className={font.key} onClick={() => props.changeFont(font)}>{font.label}</a>
      </li>
    );


    const designFonts = props.designFonts.map(font => util.getFont(font));

    const designFontsJsx = designFonts.map(font => {
      return !!font ? (<li>
          <a className={font.key} onClick={() => props.changeFont(font)} style={{fontFamily: font.font + ', serif'}}>{font.label}</a>
        </li>
      ) : null;
    });

    return (
      <div className="dropdown">
        {!props.isMobileVersion || (props.isMobileVersion && props.isMobileAside) ? 
        <a tabindex="0" className="dropdown-toggle car saf-stop">
          <span className={props.fontKey} style={{fontFamily: props.family + ', serif'}}>{props.family}</span>
        </a> :
        <a tabindex="0" className="dropdown-toggle mobile-tool-widget">
          <FontFamily />
          <span>Font</span>
        </a>}
        <div className={`fontfamily-dropdown dropdown-menu left saf-stop ${props.isMobileVersion ? 'round-bottom-corners' : ''}`}>
          {props.isMobileVersion && !props.isMobileAside && <div className="mobile-dropdown-header">
            <span>Font</span>
            <div className="dropdown-toggle"><DownOutlined/></div>
          </div>}
          <div className='font-search-div'>
            {props.isMobileVersion && !props.isMobileAside && <SearchOutlined/>}
            <input className='search-fonts' placeholder='Search font collection'
                   onClick={this.onSearchClick.bind(this)}
                   onKeyUp={util.debounce(this.onChangeSearchField.bind(this), 100)}
                   onChange={util.debounce(this.onChangeSearchField.bind(this), 100)} />
          </div>
          <div className="scroll">
            <ul>
              {designFontsJsx}
              {designFonts.length > 0 && <li className="sep"/>}
              {customFontsLabel}
              {favoriteFontHeader}
              {favoriteFontSubHeader}
              {favoriteFontBodyText}
              {customFonts}
              {!props.isMobileVersion && myFontsPromotionLbl}
              {customFontsSeparator}
              {fonts}
              <li className="sep"/>
              <li className="lbl">Multi Language</li>
              {multiLangFonts}
              <div className="no-matches lbl">no matches found</div>
            </ul>
          </div>
          {props.isMobileVersion && !props.isMobileAside && 
            <div className="mobile-upload-font-button">
              {myFontsPromotionLbl}
            </div>
          }
        </div>
      </div>
    )
  }
}
